import React, { useEffect, useRef, useState } from 'react'
import { TransProps } from '@lingui/react';
import { TimeoutId } from '@reduxjs/toolkit/dist/query/core/buildMiddleware/types';


// Type
export type typeWithTitle = {
    titleText: React.ReactElement<TransProps>
    component: React.ReactElement
    wrapStyle?: string
    titleStyle?: string
}

let timer: number | NodeJS.Timeout = 0


// Component
export const WithTitle: React.FC<typeWithTitle> = ({ titleText, component, wrapStyle, titleStyle }) => {
    const ref = useRef<HTMLDivElement | null>(null)
    let title = ref.current

    const [ isShow, setIsShow ] = useState(false)

    //did unmount
    useEffect(()=>{
        return ()=>{
            if (timer) {
                clearTimeout(timer as TimeoutId)
                setIsShow(false)
            }
        }
    },[])

    const isShowHandler = () => {

        setIsShow(true)
    }

    const setPosition = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (title) {
            title.style.top = `${ e.clientY + 20 }px`
            if (e.clientX + title.clientWidth > document.documentElement.clientWidth) {
                title.style.left = `${ e.clientX - title.clientWidth + 15 }px`
            } else {
                title.style.left = `${ e.clientX - 15 }px`
            }
        }
    }

    const mouseInHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (timer) {
            clearTimeout(timer as TimeoutId)
            setIsShow(false)
        }
        timer = setTimeout(() => {

            isShowHandler()
        }, 1000)

    }

    const style = `${ isShow ? 'opacity-100 visible' : 'opacity-0 invisible' } fixed transform transition-opacity ease-in duration-500  z-10  border border-gray-300 border rounded-md bg-gray-50 text-gray-700 px-4 py-3.5 text-xs font-medium text-center break-normal ${titleStyle}`

    return (

        <div className={ `relative  ${ wrapStyle ? wrapStyle : '' }` }
             onMouseLeave={ () => {
                 setIsShow(false)
                 clearTimeout(timer as TimeoutId)
             } }
             onMouseEnter={ (e) => {
                 mouseInHandler(e)
             } }
             onMouseMove={ (e) => {
                 setPosition(e)
             } }
        >
            { component }
            <div
                ref={ ref }
                className={ style }>
                { titleText }
            </div>

        </div>
    )
}
